'use strict';

function init() {
	var categoriesEl = document.querySelector('.newsListing__categorySelector select');
	if (!categoriesEl)
		return;

	function handleSelect() {
		var url = 'news.html?category=' + categoriesEl.value;
		history.pushState({}, '', url);

		categoriesEl.addEventListener('change', handleSelect);
	}

	categoriesEl.addEventListener('change', handleSelect);
}

module.exports = {
	init: init
}
